import Multiclient from "components/Core/Multiclient"

const LoginScreen = (props: any) => {
  return <Multiclient path_override="components/User/Login/LoginForm" />
}

export default LoginScreen
